import React from 'react';
import { Control, useController } from 'react-hook-form';

import { cn } from 'support/helpers/cn/cn';

type ToggleSwitchProps = {
  label?: string;
  name: string;
  defaultValue?: boolean;
  control: Control<any, any>;
  disabled?: boolean;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, name, control, defaultValue, disabled = false }) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({
    name,
    control,
    defaultValue,
  });

  const styles = cn(
    "peer h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-procuros-green-400 after:absolute after:top-[2px] after:left-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white dark:border-gray-600 dark:bg-gray-700",
    disabled ? 'cursor-not-allowed opacity-50' : '',
  );

  return (
    <div className="flex items-center justify-between">
      <label className="relative inline-flex cursor-pointer items-center">
        <input
          id={name}
          type="checkbox"
          onChange={onChange}
          onBlur={onBlur}
          checked={value}
          disabled={disabled}
          className="peer sr-only"
        />

        <div className={styles}>{label}</div>
      </label>
    </div>
  );
};
